import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { SecurityService } from './security.service';
import { environment } from '../../environments/environment';
import { inject } from '@angular/core';
import { PlatformIdmService } from '@platform-idm/sdk-angular';

@Injectable({ providedIn:'root' })
export class GroupGuard  {
  protected validGroups: string[];
  protected validate: () => Observable<boolean>;
  private authService: PlatformIdmService;

  constructor(private securityService: SecurityService, private router: Router) {
    this.authService = inject(PlatformIdmService);
  }
  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {

    let data = next.data;

    if (data.groupGuardValidate)
      this.validate = () => data.groupGuardValidate(this.securityService);

    if (data.groupGuardGroups)
      this.validGroups = data.groupGuardGroups;


    let forbiddenUrl = "/forbidden";
    let groups = this.validGroups;

    //validation logic or groups must be specified
    if (!this.validate && !groups) {
      this.router.navigate([forbiddenUrl]);
      return false;
    }

   
      let authenticated = await this.authService.authentication.isAuthenticated();
      if (!authenticated) {
        return false;
      }


    let ret: Observable<boolean> = null;
    if (!this.validate)
      ret = this.securityService.hasAnyGroup(groups);
    else
      ret = this.validate();

    let valid = await ret.toPromise();
    if (!valid) {
      this.router.navigate([forbiddenUrl]);
    }
    return valid;
  }
}
